import { isCanary, isDev, isPPE } from './is-environment';

export enum EnvironmentVariableKeys {
  apiServerOverride = 'apiServerOverride',
  teamsAppId = 'teamsAppId'
}

export interface IEnvironmentVariables {
  [EnvironmentVariableKeys.apiServerOverride]: string;
  [EnvironmentVariableKeys.teamsAppId]?: string;
}

export const developmentEnvironmentVariables: IEnvironmentVariables = {
  // Note: This won't apply during mock mode, or during local mode.
  [EnvironmentVariableKeys.apiServerOverride]:
    'https://ceh-canary.teams.microsoft.com/api/graphql/v1',
  [EnvironmentVariableKeys.teamsAppId]: '833f9fbf-f013-4465-a12f-439664058e86'
};

export const canaryEnvironmentVariables: IEnvironmentVariables = {
  [EnvironmentVariableKeys.apiServerOverride]:
    'https://ceh-canary.teams.microsoft.com/api/graphql/v1',
  [EnvironmentVariableKeys.teamsAppId]: '5b876856-c90d-47f8-a6fc-8de780f76cc7'
};

export const ppeEnvironmentVariables: IEnvironmentVariables = {
  [EnvironmentVariableKeys.apiServerOverride]:
    'https://ceh-ppe.teams.microsoft.com/api/graphql/v1',
  [EnvironmentVariableKeys.teamsAppId]: 'd7d081d4-d24e-4652-aea6-280db1fd2219'
};

export const prodEnvironmentVariables: IEnvironmentVariables = {
  [EnvironmentVariableKeys.apiServerOverride]:
    'https://ceh.teams.microsoft.com/api/graphql/v1',
  [EnvironmentVariableKeys.teamsAppId]: 'effd9d69-e11a-497e-a405-ff79c024e973'
};

export const getEnvironmentVariable = (
  environmentVariableKey: EnvironmentVariableKeys
): string | undefined => {
  const environmentVariables = getEnvironmentVariables();
  return environmentVariables[environmentVariableKey];
};

export const getEnvironmentVariables = (): IEnvironmentVariables => {
  if (isDev()) {
    return developmentEnvironmentVariables;
  } else if (isCanary()) {
    return canaryEnvironmentVariables;
  } else if (isPPE()) {
    return ppeEnvironmentVariables;
  } else {
    return prodEnvironmentVariables;
  }
};
